import { get, isEmpty } from 'lodash';

import { PAGE_SECTIONS } from 'constants/contentHubPage';
import Model from 'models';

const ContentHubPageModel = class extends Model {
  get heroHeadline() {
    return get(this._data, 'heroHeadline');
  }

  get heroSubheadline() {
    return get(this._data, 'heroSubheadline');
  }

  get heroBackgroundColor() {
    return get(this._data, 'heroBackgroundColor');
  }

  get heroTextColor() {
    return get(this._data, 'heroTextColor');
  }

  get heroCtaItems() {
    const items = [];

    if (this._data.heroCta1Label && this._data.heroCta1Url) {
      items.push({
        label: this._data.heroCta1Label,
        linkUrl: this._data.heroCta1Url,
      });
    }

    if (this._data.heroCta2Label && this._data.heroCta2Url) {
      items.push({
        label: this._data.heroCta2Label,
        linkUrl: this._data.heroCta2Url,
      });
    }

    return items;
  }

  get heroBackgroundImage() {
    return !isEmpty(this._data.heroBackgroundImagePortrait) &&
      !isEmpty(this._data.heroBackgroundImageLandscape)
      ? {
          portrait: {
            src: this._data.heroBackgroundImagePortrait.file.url,
            width: this._data.heroBackgroundImagePortrait.file.details.image.width,
            height: this._data.heroBackgroundImagePortrait.file.details.image.height,
          },
          landscape: {
            src: this._data.heroBackgroundImageLandscape.file.url,
            width: this._data.heroBackgroundImageLandscape.file.details.image.width,
            height: this._data.heroBackgroundImageLandscape.file.details.image.height,
          },
        }
      : null;
  }

  get articles() {
    return this._data.sections
      .filter(section => section._contentType === PAGE_SECTIONS.ARTICLE_PAGE)
      .filter(
        section => section.articleHeader && section.description && section.handle && section.image
      );
  }

  get subheader() {
    return (
      this._data.sections.find(section => section._contentType === PAGE_SECTIONS.SUBHEADER) || {}
    );
  }
};

export default ContentHubPageModel;
